import openSocket from 'socket.io-client';
const socket = openSocket('http://localhost:8000', {
    transports: ['websocket', 'polling'],
    upgrade: true,
    rememberUpgrade: true,
    timeout: 20000
});
//import {CurrentOrders} from '../Components/Orders'

export const socketService = {
    onSocketEmit,   
    initializeSocketListener 
};


function onSocketEmit(subject, data) {
    socket.emit(subject, data);
}

function initializeSocketListener() {
    console.log("hiii");
    socket.on('connect', function () { console.log("connected---------"); });
    socket.on('orderCreateInit', function (data) {
         console.log("event---------");         
    });
    socket.on('disconnect', function () { console.log("disconnect---------"); });
}


